import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTheme } from '@wise/components-theming';
import React from 'react';
function injectTheme(WrappedComponent) {
    return React.forwardRef((props, ref) => {
        const { isScreenModeDark } = useTheme();
        return _jsx(WrappedComponent, Object.assign({}, props, { isScreenModeDark: isScreenModeDark, ref: ref }));
    });
}
export default injectTheme;
